// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/feature-export/csv.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/export/src/csv.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo folio-office-app
//     node fleet/fleet.ts check --repo folio-office-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import type { ExportCellValue, ExportDataset } from "./types";

/**
 * RFC 4180-ish CSV serialization, by hand (no dependency).
 *
 * Rules applied:
 *  - Fields containing a comma, double-quote, CR or LF are wrapped in quotes.
 *  - Embedded double-quotes are escaped by doubling them.
 *  - `null`/`undefined` become empty fields; booleans become `true`/`false`.
 *  - Rows are joined with CRLF (the spec's line terminator; Excel-friendly).
 *  - CSV-injection hardening (EXPORT_K1 §4): STRING cells starting with `=`,
 *    `+`, `-`, `@` (or tab/CR) get a leading `'` so spreadsheet apps render
 *    them as text instead of executing them as formulas. Number/boolean cells
 *    are exempt: they cannot carry a formula and prefixing would corrupt
 *    honest values (e.g. negative amounts).
 */

const DELIMITER = ",";
const ROW_SEP = "\r\n";

const FORMULA_PREFIX = /^[=+\-@\t\r]/u;

function formatCell(value: ExportCellValue): string {
  if (value === null || value === undefined) {
    return "";
  }
  if (typeof value !== "string") {
    return String(value);
  }
  return FORMULA_PREFIX.test(value) ? `'${value}` : value;
}

function escapeField(raw: string): string {
  if (/[",\r\n]/u.test(raw)) {
    return `"${raw.replaceAll('"', '""')}"`;
  }
  return raw;
}

/** Serializes a {@link ExportDataset} to a CSV string (header row + data). */
export function datasetToCsv(dataset: ExportDataset): string {
  const lines: string[] = [];
  lines.push(dataset.columns.map((c) => escapeField(c.header)).join(DELIMITER));
  for (const row of dataset.rows) {
    lines.push(row.map((cell) => escapeField(formatCell(cell))).join(DELIMITER));
  }
  // Trailing newline keeps POSIX tools (and `wc -l`) happy.
  return lines.join(ROW_SEP) + ROW_SEP;
}
